export function percentageCalculate(percent: number, total: number) {
    return +((percent / total) * 100).toFixed(2);
}
